import { STRATEGY_NAMES, type StrategyKey } from '../../lib/modelNames';
import styles from './Btc15ModelComparison.module.css';

/** What the strategy is, then its nickname in smaller type. */
export function StrategyHeading({ strategy }: { strategy: StrategyKey }) {
  const { name, descriptor } = STRATEGY_NAMES[strategy];
  return (
    <span className={styles.columnLabel}>
      {descriptor}
      <span className={styles.nickname}>{name}</span>
    </span>
  );
}
